import apiClient from '../../../services/apiClient';
import { exportData } from '../../../utils/exportData';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';

const ApiClient = async (method, route, data = {}) => {
  try {
    let response;
    if (method === 'post') {
      response = await apiClient.post(route, data);
    } else if (method === 'get') {
      response = await apiClient.get(route, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(route, data);
    }
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};
export const importCustomers = async (formData) => {
  return await importData('/customers/import', formData);
};
export const importCustomerGroups = async (formData) => {
  return await importData('/customer-group/import', formData);
};
export const importData = async (route, formData) => {
  try {
    const response = await apiClient.post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('data', response);

    showSuccessToast(response?.data?.message || '');
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};

export const fetchCustomers = async (query) => {
  return await ApiClient('get', '/customers', query);
};
export const addCustomer = async (data) => {
  return await ApiClient('post', '/customers', data);
};
export const updateCustomer = async (data, id) => {
  return await ApiClient('put', '/customers/' + id, data);
};
export const fetchAreas = async () => {
  return await ApiClient('get', '/customers/areas');
};
export const fetchCategories = async () => {
  return await ApiClient('get', '/customers/categories');
};
export const fetchDistricts = async () => {
  return await ApiClient('get', '/customers/districts');
};
export const fetchLogisticLines = async () => {
  return await ApiClient('get', '/customers/logistic-lines');
};
export const fetchPaymentMethods = async () => {
  return await ApiClient('get', '/customers/payment-methods');
};
export const generateProductCode = async () => {
  return await ApiClient('get', '/customers/generate-code');
};

export const addCustomerGroup = async (data) => {
  return await ApiClient('post', '/customer-group', data);
};
export const fetchCustomerGroups = async (query) => {
  return await ApiClient('get', '/customer-group', query);
};
export const updateCustomerGroups = async (data, customerGroupId) => {
  return await ApiClient('put', '/customer-group/' + customerGroupId, data);
};

export const exportCustomerGroups = async (filters, fileName) => {
  return await exportData('/customer-group/export', filters, fileName);
};
export const exportCustomers = async (filters, fileName) => {
  return await exportData('/customers/export', filters, fileName);
};
